import {Box, BoxProps, Typography} from '@mui/material';

interface Props extends BoxProps {
  heading: string;
}

export default function SubSectionHeading(props: Props) {
  return (
    <Box
      {...props}
      sx={{
        background: '#F3F7FA',
        padding: '12px 16px',
        ...props.sx,
      }}
    >
      <Typography fontSize={14} fontWeight={500}>
        {props.heading}
      </Typography>
    </Box>
  );
}
